// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupPermissionsPopup__content-ddc017 {
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  overflow: auto;
}

.GroupPermissionsPopup__divider-f2b5a3 {
  background-color: var(--base-15);
  margin-top: 10px;
  margin-bottom: 10px;
  height: 12px;
  flex-shrink: 0;
}

.GroupPermissionsPopup__caption-d9658a {
  font: var(--font-button);
  letter-spacing: var(--font-spacing-button);
  color: var(--base-80);
  padding: 16px 24px 0;
}

.GroupPermissionsPopup__switch-c57cca {
  padding: 12px 24px;
}

.GroupPermissionsPopup__switch-with-description-c6bf02 {
  padding: 8px 24px;
}

.GroupPermissionsPopup__footer-eb56a7 {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 16px 24px 16px;
}

.GroupPermissionsPopup__button-d6987b {
  align-self: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/GroupPermissionsPopup/GroupPermissionsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,OAAA;EACA,cAAA;AACF;;AAEA;EACE,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".content {\n  padding: 8px 0px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1;\n  overflow: auto;\n}\n\n.divider {\n  background-color: var(--base-15);\n  margin-top: 10px;\n  margin-bottom: 10px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.caption {\n  font: var(--font-button);\n  letter-spacing: var(--font-spacing-button);\n  color: var(--base-80);\n  padding: 16px 24px 0;\n}\n\n.switch {\n  padding: 12px 24px;\n}\n\n.switch-with-description {\n  padding: 8px 24px;\n}\n\n.footer {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 24px 16px;\n}\n\n.button {\n  align-self: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `GroupPermissionsPopup__content-ddc017`,
	"divider": `GroupPermissionsPopup__divider-f2b5a3`,
	"caption": `GroupPermissionsPopup__caption-d9658a`,
	"switch": `GroupPermissionsPopup__switch-c57cca`,
	"switch-with-description": `GroupPermissionsPopup__switch-with-description-c6bf02`,
	"switchWithDescription": `GroupPermissionsPopup__switch-with-description-c6bf02`,
	"footer": `GroupPermissionsPopup__footer-eb56a7`,
	"button": `GroupPermissionsPopup__button-d6987b`
};
module.exports = ___CSS_LOADER_EXPORT___;
